import {useContext} from "react";
import {ArticleFormContext} from "../contexts/article-form-context";

export const useArticleForm = () => {
    const context = useContext(ArticleFormContext);
    if (!context) {
        throw new Error('useArticleForm must be used within ArticleFormProvider');
    }
    return context;
};
